import { render, staticRenderFns } from "./editorTopMenu.vue?vue&type=template&id=66041e39&scoped=true"
import script from "./editorTopMenu.vue?vue&type=script&lang=js"
export * from "./editorTopMenu.vue?vue&type=script&lang=js"
import style0 from "./editorTopMenu.vue?vue&type=style&index=0&id=66041e39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66041e39",
  null
  
)

export default component.exports